import React, { Fragment } from "react";
import GuestGuard from "./components/Auth/GuestGuard";
import AuthGuard from "./components/Auth/AuthGuard";
import { Navigate, Route } from "react-router-dom";
import SadAntLayout from "./containers/SadAntLayout";
import CogSpaceDashboard from "./views/dashboard/CogSpaceDashboard";
import PermissionGuard from "./auth/permissions/PermissionGuard";
import { getRoutePermission } from "./auth/permissions/permissionMap";
// import ReviewDataAndDefineConcepts from './views/MainPages/ReviewDataAndDefineConcepts/ReviewDataAndDefineConcepts';

export const renderRoutes = (
	routes = [],
	tguard = Fragment,
	tLayout = Fragment
) => {
	let map = routes.map((route, i) => {
		const Guard = route.guard || tguard;
		const Layout = route.layout || tLayout;
		const Component = route.component;
		const permissionRequirement =
			route.permission || getRoutePermission(route.path);

		// return (<Route
		//   key={i}
		//   path={route.path}
		//   exact={route.exact}
		//   render={(props) => (
		//     <Guard>
		//       <Layout>{route.routes ? renderRoutes(route.routes) : <Component {...props} />}</Layout>
		//     </Guard>
		//   )}
		// />)
		return route.routes ? (
			renderRoutes(route.routes, Guard, Layout)
		) : (
			<Route
				key={"rout-" + i}
				path={route.path}
				exact={route.exact}
				element={
					<Guard>
						<PermissionGuard requirement={permissionRequirement}>
							<Layout>
								<Component />
							</Layout>
						</PermissionGuard>
					</Guard>
				}
			/>
		);
	});
	return map;
};

const routes = [
	// {
	//   exact: true,
	//   path: "/login-page",
	//   guard: GuestGuard,
	//   component: React.lazy(() => import('./views/auth/user/SignIn1'))
	// },
	{
		exact: true,
		guard: GuestGuard,
		path: "/auth/signin",
		name: "Sign-in",
		component: React.lazy(() => import("./views/user/SignIn1")),
	},
	// {
	//   exact: true,
	//   path: "/logout",
	//   guard: GuestGuard,
	//   component: LogoutPage,
	// },
	{
		path: "*",
		layout: SadAntLayout,
		guard: AuthGuard,
		routes: [
			// {
			//     exact: true,
			//     path: "/dashboard-page",
			//     component: () => <Navigate to={'/dashboard-page'}/>,
			//     name: 'صفحه نخست',
			// },
			{
				exact: true,
				path: "/dashboard-page",
				component: CogSpaceDashboard,
				name: "صفحه نخست",
			},
			{
				exact: true,
				path: "/ModelTraining",
				component: React.lazy(() =>
					import("./views/MainPages/ModelTraining/ModelTraining")
				),
				name: "تحلیل دادگان",
			},
			{
				exact: true,
				path: "/FileFilter",
				component: React.lazy(() =>
					import("./views/MainPages/ModelTraining/FileFilter")
				),
				name: "فیلتر فایل",
			},
			{
				exact: true,
				path: "/BasedOnTimeDatasetCreating",
				component: React.lazy(() =>
					import("./views/MainPages/ModelTraining/BasedOnTimeDatasetCreating")
				),
				name: "ساخت مجموعه داده زمانی",
			},
			{
				exact: true,
				path: "/WordsSuggestion",
				component: React.lazy(() =>
					import("./views/MainPages/WordsSuggestion/WordsSuggestion")
				),
				name: "پیشنهاد واژگان",
			},
			{
				exact: true,
				path: "/ReviewDataAndDefineConcepts",
				component: React.lazy(() =>
					import(
						"./views/MainPages/ReviewDataAndDefineConcepts/ReviewDataAndDefineConcepts"
					)
				),
				name: "مطالعه مفاهیم مورد نظر",
			},
			{
				exact: true,
				path: "/ReviewNonMetricSpace",
				component: React.lazy(() =>
					import("./views/MainPages/ReviewNonMetricSpace/ReviewNonMetricSpace")
				),
				name: "بازبینی فضای شناختی غیر متریک",
			},
			{
				exact: true,
				path: "/ReviewNonMetricSpace/:extension",
				component: React.lazy(() =>
					import("./views/MainPages/ReviewNonMetricSpace/ReviewNonMetricSpace")
				),
				name: "بازبینی فضای شناختی غیر متریک",
			},
			{
				exact: true,
				path: "/ReviewMetricSpace",
				component: React.lazy(() =>
					import("./views/MainPages/ReviewMetricSpace/ReviewMetricSpace")
				),
				name: "بررسی فضای شناختی متریک",
			},
			{
				exact: true,
				path: "/ReviewTopicalMetricSpace",
				component: React.lazy(() =>
					import("./views/MainPages/ReviewMetricSpace/ReviewTopicalMetricSpace")
				),
				name: "بررسی فضای شناختی موضوعی متریک",
			},
			{
				exact: true,
				path: "/VocabularyMetricSpaceComparison",
				component: React.lazy(() =>
					import(
						"./views/MainPages/ReviewMetricSpace/VocabularyMetricSpaceComparison"
					)
				),
				name: "مقایسه دو فضای شناختی بر اساس نشانش واژگان",
			},
			{
				exact: true,
				path: "/TopicalMetricSpaceComparison",
				component: React.lazy(() =>
					import(
						"./views/MainPages/ReviewMetricSpace/TopicalMetricSpaceComparison"
					)
				),
				name: "مقایسه دو فضای شناختی بر اساس تحلیل موضوعی ساده",
			},
			{
				exact: true,
				path: "/TopicalWeightedMetricSpaceComparison",
				component: React.lazy(() =>
					import(
						"./views/MainPages/ReviewMetricSpace/TopicalWeightedMetricSpaceComparison"
					)
				),
				name: "مقایسه دو فضای شناختی بر اساس تحلیل موضوعی وزن دار",
			},
			{
				exact: true,
				path: "/EstimatingBiasWithSupervision",
				component: React.lazy(() =>
					import(
						"./views/MainPages/EstimatingBias/EstimatingBiasWithSupervision"
					)
				),
				name: "تخمین سوگیری با نظارت",
			},
			{
				exact: true,
				path: "/EstimatingBiasUnsupervised",
				component: React.lazy(() =>
					import("./views/MainPages/EstimatingBias/EstimatingBiasUnsupervised")
				),
				name: "تخمین سوگیری بدون نظارت",
			},
			{
				exact: true,
				path: "/ReviewCognitiveBias",
				component: React.lazy(() =>
					import("./views/MainPages/ReviewCognitiveBias/ReviewCognitiveBias")
				),
				name: "بررسی سو گیری های شناختی مورد نظر",
			},
			{
				exact: true,
				path: "/WordSuggestions",
				component: React.lazy(() =>
					import(
						"./views/MainPages/ReviewDataAndDefineConcepts/WordSuggestions"
					)
				),
				name: "پیشنهاد معنایی واژگان",
			},
			{
				exact: true,
				path: "/ProportionalityBetweenConcepts",
				component: React.lazy(() =>
					import(
						"./views/MainPages/ReviewDataAndDefineConcepts/ProportionalityBetweenConcepts"
					)
				),
				name: "نسبت سنجی بین مفاهیم",
			},
			{
				exact: true,
				path: "/DesignMultipleChoiceQuestions",
				component: React.lazy(() =>
					import(
						"./views/MainPages/ReviewDataAndDefineConcepts/DesignMultipleChoiceQuestions"
					)
				),
				name: "طرح سوالات چند گزینه ای(طیفی)",
			},
			{
				exact: true,
				path: "/CommunityAnalysis",
				component: React.lazy(() =>
					import("./views/MainPages/CommunityAnalysis/CommunityAnalysis.js")
				),
				name: "تحلیل جوامع کاربری",
			},
			{
				path: "/TopicChoose",
				component: React.lazy(() =>
					import("./views/MainPages/CommunityAnalysis/TopicChoose.js")
				),
				name: "انتخاب تحلیل",
			},
			{
				exact: true,
				path: "/InfluentialUsersRecognition",
				component: React.lazy(() =>
					import(
						"./views/MainPages/CommunityAnalysis/InfluentialUsersRecognition.js"
					)
				),
				name: "شناسایی کاربران تاثیرگذار",
			},
			{
				exact: true,
				path: "/DeepInfluentialUsersRecognition",
				component: React.lazy(() =>
					import(
						"./views/MainPages/CommunityAnalysis/DeepInfluentialUsersRecognition.js"
					)
				),
				name: "شناسایی عمیق کاربران تاثیرگذار",
			},
			{
				exact: true,
				path: "/PezvakRoom",
				component: React.lazy(() =>
					import(
						"./views/MainPages/CommunityAnalysis/PezvakRoom.js"
					)
				),
				name: "اتاق پژواک",
			},
			{
				exact: true,
				path: "/TopicRecognitionBarchart",
				component: React.lazy(() =>
					import(
						"./views/MainPages/CommunityAnalysis/TopicRecognitionBarchart.js"
					)
				),
				name: "تحلیل موضوعی با ایست واژه",
			},
			{
				exact: true,
				path: "/ProductionNews",
				component: React.lazy(() =>
					import(
						"./views/MainPages/ProductionNarrative/ProductionNews.js"
					)
				),
				name: "تولید خبر",
			},
			{
				exact: true,
				path: "/CredibleNarratives",
				component: React.lazy(() =>
					import(
						"./views/MainPages/ProductionNarrative/CredibleNarratives.js"
					)
				),
				name: "تولید روایت باورپذیر",
			},
			{
				exact: true,
				path: "/EnvManagement",
				component: React.lazy(() =>
					import(
						"./views/MainPages/EnvManagement.js"
					)
				),
				name: "مدیریت دسترسی به مدل زبانی",
			},
			{
				exact: true,
				path: "/UsersProfile",
				component: React.lazy(() =>
					import(
						"./views/MainPages/Polling/UsersProfiles.js"
					)
				),
				name: " ساخت پروفایل کاربران",
			},
			{
				exact: true,
				path: "/Survey",
				component: React.lazy(() =>
					import(
						"./views/MainPages/Polling/Survey.js"
					)
				),
				name: "نظرسنجی",
			},
			{
				exact: true,
				path: "/NationalSurvey",
				component: React.lazy(() =>
					import(
						"./views/MainPages/Polling/NationalSurvey.js"
					)
				),
				name: "اعتبارسنجی",
			},
			{
				exact: true,
				path: "/TwoLayerSorting",
				component: React.lazy(() =>
					import(
						"./views/MainPages/Classification/TwoLayerSorting.js"
					)
				),
				name: "دسته‌بندی دو لایه",
			},
			{
				exact: true,
				path: "/TopicRecognitionBarchartWithoutStopWords",
				component: React.lazy(() =>
					import(
						"./views/MainPages/CommunityAnalysis/TopicRecognitionBarchartWithoutStopWords.js"
					)
				),
				name: "تحلیل موضوعی بدون ایست واژه",
			},
			{
				exact: true,
				path: "/UserDashboard",
				component: React.lazy(() =>
					import(
						"./views/MainPages/UserDashboard.js"
					)
				),
				name: "داشبورد کاربران",
			},
			{
				exact: true,
				path: "/TopicalAnalysisOverTime",
				component: React.lazy(() =>
					import(
						"./views/MainPages/CommunityAnalysis/TopicalAnalysisOverTime.js"
					)
				),
				name: "تحلیل موضوعی در طول زمان",
			},
			{
				exact: true,
				path: "/TopicRecognitionBubble",
				component: React.lazy(() =>
					import(
						"./views/MainPages/CommunityAnalysis/TopicRecognitionBubble.js"
					)
				),
				name: "تحلیل ارتباط بین موضوعات",
			},
			{
				exact: true,
				path: "/TopicRecognitionSentence",
				component: React.lazy(() =>
					import(
						"./views/MainPages/CommunityAnalysis/TopicRecognitionSentence.js"
					)
				),
				name: " تحلیل ارتباط بین موضوعات",
			},
			{
				exact: true,
				path: "/TopicRecognitionNew",
				component: React.lazy(() =>
					import("./views/MainPages/CommunityAnalysis/TopicRecognitionNew.js")
				),
				name: "تحلیل جوامع کاربری",
			},
			{
				exact: true,
				path: "/TopicRecognitionDotplot",
				component: React.lazy(() =>
					import(
						"./views/MainPages/CommunityAnalysis/TopicRecognitionDotplot.js"
					)
				),
				name: "تحلیل ارتباط بین جوامع",
			},
			{
				exact: true,
				path: "/TopicRecognitionBubbleAndSingleDotplot",
				component: React.lazy(() =>
					import(
						"./views/MainPages/CommunityAnalysis/TopicRecognitionBubbleAndSingleDotplot.js"
					)
				),
				name: "شناسایی و تحلیل خوشه‌های درون و برون موضوعی",
			},
			{
				exact: true,
				path: "/TopicRecognitionTopicsDateDotplot",
				component: React.lazy(() =>
					import(
						"./views/MainPages/CommunityAnalysis/TopicRecognitionTopicsDateDotplot.js"
					)
				),
				name: "شناسایی اخبار جعلی / داغ شدن موضوعات",
			},
			{
				exact: true,
				path: "/TopicRecognitionTopicsUsersDotplot",
				component: React.lazy(() =>
					import(
						"./views/MainPages/CommunityAnalysis/TopicRecognitionTopicsUsersDotplot.js"
					)
				),
				name: "شناسایی افرادی مرتبط از لحاظ ذهنی",
			},
			{
				exact: true,
				path: "/CreatePerceptionRequest",
				component: React.lazy(() =>
					import(
						"./views/MainPages/Perception/CreatePerceptionRequest.js"
					)
				),
				name: " ساخت تحلیل ادراکی",
			},
			{
				exact: true,
				path: "/ExaminingHypothesesAndQuestionsInDocuments",
				component: React.lazy(() =>
					import(
						"./views/MainPages/Perception/ExaminingHypothesesAndQuestionsInDocuments.js"
					)
				),
				name: " بررسی سوال در اسناد",
			},
			{
				exact: true,
				path: "/ReviewRelatedDocuments",
				component: React.lazy(() =>
					import(
						"./views/MainPages/Perception/ReviewRelatedDocuments.js"
					)
				),
				name: " بررسی اسناد مرتبط",
			},
			{
				exact: true,
				path: "/GeneralOverviewDocument",
				component: React.lazy(() =>
					import(
						"./views/MainPages/Perception/GeneralOverviewDocuments.js"
					)
				),
				name: "دیدگاه کلی استاد",
			},
			{
				exact: true,
				path: "/CheckingAssumptionsInDocs",
				component: React.lazy(() =>
					import(
						"./views/MainPages/Perception/CheckingAssumptionsInDocs.js"
					)
				),
				name: "بررسی فرضیات در اسناد",
			},
			{
				exact: true,
				path: "/ManagementSummary",
				component: React.lazy(() =>
					import(
						"./views/MainPages/Perception/ManagementSummary.js"
					)
				),
				name: " خلاصه مدیریتی",
			},
			{
				exact: true,
				path: "/Tagging",
				component: React.lazy(() =>
					import(
						"./views/MainPages/Perception/Tagging.js"
					)
				),
				name: " برچسب زنی",
			},
			{
				exact: true,
				path: "/LexicalSemantic",
				component: React.lazy(() =>
					import(
						"./views/MainPages/LexicalSemanticAnalysis/LexicalSemantic.js"
					)
				),
				name: "تحلیل معنایی واژگان",
			},
			{
				exact: true,
				path: "/ThinkThankAffects",
				component: React.lazy(() =>
					import(
						"./views/MainPages/Perception/ThinkThankAffects.js"
					)
				),
				name: "تاثیر اندیشکده‌ها",
			},
			{
				exact: true,
				path: "/TopicRecognitionDotplot",
				component: React.lazy(() =>
					import("./views/MainPages/CommunityAnalysis/TopicRecognitionDotplot")
				),
				name: "تحلیل جوامع کاربری",
			},
			{
				exact: true,
				path: "/messageStudy",
				component: React.lazy(() =>
					import("./views/MainPages/MessageStudy/MessageStudy")
				),
				name: "مطالعه پیام",
			},
			{
				exact: true,
				path: "/messageDesign",
				component: React.lazy(() =>
					import("./views/MainPages/MessageDesigner/MessageDesigner")
				),
				name: "طراحی پیام",
			},
			{
				exact: true,
				path: "/contactus",
				component: React.lazy(() => import("./views/About/ContactUsView")),
				name: "تماس با ما",
			},
			{
				exact: true,
				path: "/intro",
				component: React.lazy(() => import("./views/About/IntroView")),
				name: "معرفی",
			},
			{
				exact: true,
				path: "/qa",
				component: React.lazy(() => import("./views/About/QAView")),
				name: "سوالات متداول",
			},
			{
				exact: true,
				path: "/help",
				component: React.lazy(() => import("./views/About/Help")),
				name: "راهنما",
			},
			{
				exact: true,
				path: "/userprofile",
				component: React.lazy(() => import("./views/user/UserProfile")),
				name: "پنل کاربری",
			},
			{
				exact: true,
				path: "/usersettings",
				component: React.lazy(() => import("./views/user/UserSetting")),
				name: "پنل کاربری",
			},
			{
				exact: true,
				path: "/userrequest",
				component: React.lazy(() => import("./views/UserRequests/UserRequest")),
				name: "درخواست های کاربر",
			},
			{
				exact: true,
				path: "/useradmin",
				component: React.lazy(() => import("./views/Admin/UserAdminPage")),
				name: "پنل مدیریت پایش فضای شناختی",
			},
			{
				exact: true,
				path: "/serviceadmin",
				component: React.lazy(() => import("./views/Admin/ServiceAdminPage")),
				name: "پنل مدیریت سرویس ها",
			},
			{
				path: "*",
				exact: true,
				component: () => <Navigate to={"/dashboard-page"} />,
			},
		],
	},
];

export default routes;
